import { Column } from '../../components/Table/Table';

export const Columns = (t): Column[] => [
    { id: 'name', label: t('Master-data.audit-types.table-col-1') },
    { id: 'layoutName', label: t('Master-data.audit-types.table-col-2'), minWidth: 200 },
];
